import { observable, runInAction } from 'mobx';
import { IUnfollowRemindServices, UnfollowRemind } from 'services/Masterdata/unfollowRemind_services';
import { DataResponse } from 'services/response';


export type unfollowRemindStore = {
  listUnfollowRemindRespone: DataResponse<UnfollowRemind[]>
  createUpdateRes: DataResponse<null>
};

export interface IUnfollowRemindPresenter {
  createStore(): unfollowRemindStore;
  searchData(store: unfollowRemindStore, data: object): Promise<void>
  delete(store: unfollowRemindStore, id: string): Promise<void>
  create(store: unfollowRemindStore, data: object): Promise<void>
}

export function createUnfollowRemindPresenter({ unfollowRemindServices }: { unfollowRemindServices: IUnfollowRemindServices }): IUnfollowRemindPresenter {
  return {
    createStore: (): unfollowRemindStore =>
      observable({
        listUnfollowRemindRespone: {
          data: [],
          message: '',
          isSuccess: false,
        },
        createUpdateRes: {
          data: null,
          message: '',
          isSuccess: false,
        },
      }),
    searchData: async (store: unfollowRemindStore, data) => {
      try {
        const result = await unfollowRemindServices.searchData(data);
        runInAction(() => {
          store.listUnfollowRemindRespone.data = result.data;
          store.listUnfollowRemindRespone.isSuccess = result.isSuccess;
          store.listUnfollowRemindRespone.message = result.message;
          store.listUnfollowRemindRespone.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // create
    create: async (store: unfollowRemindStore, data) => {
      try {
        const result = await unfollowRemindServices.create(data);
        runInAction(() => {
          store.createUpdateRes.isSuccess = result.isSuccess;
          store.createUpdateRes.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // delete
    delete: async (store: unfollowRemindStore, id) => {
      try {
        const result = await unfollowRemindServices.delete(id);
        runInAction(() => {
          store.createUpdateRes.isSuccess = result.isSuccess;
          store.createUpdateRes.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
